<template>
  <div class="card">
    <div class="card-header">
      <h4>{{ isEdit ? 'Editar Tema' : 'Cadastrar Tema' }}</h4>
    </div>

    <div class="card-body">
      <form @submit.prevent="salvar">
        <div class="row">

          <!-- Nome do Tema -->
          <div class="col-md-6 mb-3">
            <label>Nome do Tema</label>
            <input
              type="text"
              class="form-control"
              v-model="form.nome_tema"
              required
            />
          </div>

          <!-- Arquivo CSS -->
          <div class="col-md-4 mb-3">
            <label>Arquivo CSS</label>
            <select
              class="form-control"
              v-model="form.slug"
              required
            >
              <option value="" disabled>Selecione</option>
              <option value="tema-um">tema-um.css</option>
              <option value="tema-dois">tema-dois.css</option>
              <option value="tema-tres">tema-tres.css</option>
            </select>
          </div>

          <!-- Ativo -->
          <div class="col-md-2 mb-3">
            <label>Ativo</label>
            <select
              class="form-control"
              v-model="form.ativo_sn"
              required
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>

        </div>

        <div class="text-right mt-3">
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading"
          >
            {{ loading ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      form: {
        nome_tema: '',
        slug: '',
        ativo_sn: 'N'
      }
    }
  },

  computed: {
    isEdit() {
      return !!this.id
    }
  },

  mounted() {
    if (this.isEdit) {
      this.carregarTema()
    }
  },

  methods: {
    carregarTema() {
      this.loading = true

      axios
        .get(`/api/dashboard/admin/tema-dinamico/${this.id}`)
        .then(response => {
          const data = response.data

          this.form.nome_tema = data.nome_tema
          this.form.slug = data.slug
          this.form.ativo_sn = data.ativo_sn
        })
        .finally(() => {
          this.loading = false
        })
    },

    salvar() {
      this.loading = true

      const request = this.isEdit
        ? axios.put(`/api/dashboard/admin/tema-dinamico/${this.id}`, this.form)
        : axios.post('/api/dashboard/admin/tema-dinamico', this.form)

      request
        .then(response => {
          this.$toast?.success('Tema salvo com sucesso!')

          const id = this.isEdit ? this.id : response.data.id
          const rotaDestino = `/dashboard/admin/tema-dinamico/${id}`

          if (this.$route.fullPath !== rotaDestino) {
            this.$router.push(rotaDestino)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }


  }
  
}
</script>
